import { render, staticRenderFns } from "./SetupStatusIcon.vue?vue&type=template&id=629922fc&scoped=true"
import script from "./SetupStatusIcon.vue?vue&type=script&lang=js"
export * from "./SetupStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629922fc",
  null
  
)

export default component.exports